import { Credentials } from '../states/LoginSessionState'

export default class CredentialsStorage {
  static storageKey: string = 'credentials'

  getCredentials (): Credentials | null {
    // TODO: maybe need to consider security issue of localStorage?
    // what about use cookie instead?
    const item = localStorage.getItem(CredentialsStorage.storageKey)
    if (!item) {
      return null
    }
    return JSON.parse(item)
  }

  updateCredentials (credentails: Credentials) {
    localStorage.setItem(
      CredentialsStorage.storageKey,
      JSON.stringify(credentails)
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/CredentialsStorage.ts